import React, { createContext, useState, useEffect,useContext ,useCallback } from "react";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { useNavigate } from "react-router-dom";
 
export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userToken, setUserToken] = useState(null);
  const [refresh_token, setRefresh_token] = useState(null);
  const [role, setRole] = useState("");
  const [addresses, setAddresses] = useState({});

  const [deviceId, setDeviceId] = useState("");
  const [user_id, setUser_id] = useState("");
  const [showSidebar, setShowSidebar] = useState(false);
// console.log(showSidebar)
  const rememberMe = localStorage.getItem("rememberMe") === "true";
  // The "setRememberMeValue" function will be used to update the "rememberMe" value.
  const [rememberMeValue, setRememberMeValue] = useState(rememberMe);

  useEffect(() => {
    const storedUserToken = rememberMeValue
      ? localStorage.getItem("userToken")
      : sessionStorage.getItem("userToken");

    const storedRefreshToken = rememberMeValue
      ? localStorage.getItem("refreshToken")
      : sessionStorage.getItem("refreshToken");

    if (storedUserToken) {
      try {
        const decodedToken = jwt_decode(storedUserToken);
        const newRole = decodedToken.role;
        const newDeviceId = decodedToken.device_id;
        const userId = decodedToken.user_id;
        setRole(newRole);
        setDeviceId(newDeviceId);
        setUser_id(userId);
      } catch (error) {
        console.error("Invalid token specified", error);
        setRole("");
        setDeviceId("");
      }
    }

    if (storedUserToken) {
      const tokenExpiration = new Date(
        jwt_decode(storedUserToken).exp * 1000
      );
      if (tokenExpiration >= new Date()) {
        setIsLoggedIn(true);
        setUserToken(storedUserToken);
        setRefresh_token(storedRefreshToken);
      }
    }
  }, [rememberMeValue]);

  const checkUserToken = () => {
    if (!userToken || userToken === "undefined") {
      setIsLoggedIn(false);
      if (rememberMeValue) {
        localStorage.setItem("rememberMe", "false");
      } else {
        sessionStorage.setItem("rememberMe", "false");
      }
      if (window.location.pathname.includes("password-reset")) {
      } else {
        // navigate("/");
      }
    } else {
      const decodedToken = jwt_decode(userToken);
      const tokenExpiration = new Date(decodedToken.exp * 1000);
      if (tokenExpiration < new Date()) {
        refreshTokens();
      } else {
        setIsLoggedIn(true);
        setUser_id(decodedToken.user_id);
        if (rememberMeValue) {
          localStorage.setItem("rememberMe", "true");
        } else {
          sessionStorage.setItem("rememberMe", "true");
        }
        const newExpirationTimestamp = decodedToken.exp * 1000;
        const newTimeUntilExpiration = newExpirationTimestamp - Date.now();
        setTimeout(refreshTokens, newTimeUntilExpiration - 60000);
      }
    }
  };

  let isRefreshing = false;
  const refreshTokens = async () => {
    console.log(refresh_token);
        if (isRefreshing) {
      return;
    }
    isRefreshing = true;
    let refreshInterval;
  
    try {
      const response = await axios.post("/token/refresh", {
        refresh: refresh_token,
      });
      if (response.data.access) {
        setIsLoggedIn(true);
        if (rememberMe === "true") {
          localStorage.setItem("isLoggedIn", true);
        } else {
          sessionStorage.setItem("isLoggedIn", true);
        }
        const newToken = response.data.access;
        const newTokenData = jwt_decode(newToken);

        if (rememberMe === "true") {
          localStorage.setItem("user-token", newToken);
          localStorage.setItem("refresh_token", response.data.refresh);
        } else {
          sessionStorage.setItem("user-token", newToken);
          sessionStorage.setItem("refresh_token", response.data.refresh);
        }

        setUserToken(newToken);
        setRefresh_token(response.data.refresh);
        localStorage.setItem("user_id", newTokenData.user_id);
        setUser_id(newTokenData.user_id);

        const newExpirationTimestamp = newTokenData.exp * 1000;
        const newTimeUntilExpiration = newExpirationTimestamp - Date.now();
        if (isLoggedIn) {
          refreshInterval = setInterval(
            () => refreshTokens(),
            newTimeUntilExpiration - 60000
          );
          clearInterval(refreshInterval);
        }
      } else if (response.data.code === "token_not_valid") {
        if (rememberMe === "true") {
          localStorage.setItem("isLoggedIn", false);
        } else {
          sessionStorage.setItem("isLoggedIn", false);
        }
        clearInterval(refreshInterval);
        setIsLoggedIn(false);
        localStorage.removeItem("user-token");
        setUserToken(null);
        localStorage.removeItem("refresh_token");
        setRefresh_token(null);
        navigate("/");
      }
    } catch (error) {
      if (rememberMe === "true") {
        localStorage.setItem("isLoggedIn", false);
      } else {
        sessionStorage.setItem("isLoggedIn", false);
      }
      clearInterval(refreshInterval);
      setIsLoggedIn(false);
      localStorage.removeItem("user-token");
      setUserToken(null);
      localStorage.removeItem("refresh_token");
      setRefresh_token(null);
      navigate("/");
    } finally {
      isRefreshing = false;
    }
  };

  useEffect(() => {
    checkUserToken();
  }, [refresh_token]);

  const toggleSidebar = useCallback(() => {
    setShowSidebar((prevShowSidebar) => !prevShowSidebar);
  }, []);

  

  return (
    <UserContext.Provider
    value={{
      isLoggedIn,
      setIsLoggedIn,
      userToken,
      setUserToken,
      refresh_token,
      setRefresh_token,
      user_id,
      role,
      setRole,
      deviceId,
      setDeviceId,
      // Include the "setRememberMeValue" function in the context
      setRememberMeValue,
      showSidebar, 
      setShowSidebar,
      toggleSidebar,addresses,setAddresses
    }}
  >
    {children}
  </UserContext.Provider>
  );
};
export const useUser = () => {
  return useContext(UserContext);
};